import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-93d10ae0")

_pushScopeId("data-v-93d10ae0")
const _hoisted_1 = { class: "r-grid container" }
const _hoisted_2 = {
  key: 0,
  class: "r-grid message"
}
const _hoisted_3 = {
  key: 0,
  class: "select-all-container"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { for: "select-all" }, "Select All", -1)
const _hoisted_5 = { class: "checkbox-container" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "date" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", null, "Supervisor Comment", -1)
const _hoisted_10 = { class: "button-group" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_accordion_title = _resolveComponent("accordion-title")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_accordion_title, {
        title: _ctx.title,
        toggle: _ctx.listToggle,
        "onUpdate:toggle": _cache[1] || (_cache[1] = ($event: any) => (_ctx.listToggle = $event)),
        onUpdateToggle: _cache[2] || (_cache[2] = ($event: any) => (_ctx.listToggle = $event))
      }, null, 8, ["title", "toggle"])
    ]),
    (_ctx.userLeaveList && _ctx.userLeaveList.length === 0)
      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_2, " No items to display. ", 512)), [
          [_vShow, _ctx.listToggle]
        ])
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("form", {
      class: "r-grid",
      onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
      role: "form",
      "aria-label": "view and edit pending requests"
    }, [
      (_ctx.userLeaveList && _ctx.userLeaveList.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("input", {
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectAll($event))),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectAllState = !_ctx.selectAllState)),
              id: "select-all",
              type: "checkbox",
              "aria-label": "select all",
              role: "checkbox",
              "aria-checked": _ctx.selectAllState
            }, null, 40, ["aria-checked"]),
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      _createVNode("ol", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userLeaveList, (item, index) => {
          return (_openBlock(), _createBlock("li", {
            class: "grid-container",
            key: index
          }, [
            _createVNode("div", _hoisted_5, [
              _withDirectives((_openBlock(), _createBlock("input", {
                "onUpdate:modelValue": ($event: any) => (item.boolean = $event),
                onChange: ($event: any) => (_ctx.toggleCheckboxLeave($event, item.uuid, item.duration_hours, )),
                type: "checkbox",
                class: "multi-select",
                "aria-label": "pending request",
                onClick: ($event: any) => (item.boolean = !item.boolean),
                role: "checkbox",
                key: index,
                "aria-checked": item.boolean
              }, null, 40, ["onUpdate:modelValue", "onChange", "onClick", "aria-checked"])), [
                [_vModelCheckbox, item.boolean],
                [_vShow, _ctx.listToggle]
              ])
            ]),
            _createVNode("div", {
              class: ["status-color", item.status]
            }, null, 2),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, _toDisplayString(_ctx.formatDate(item.date)), 1),
              _createVNode("div", {
                class: "status",
                innerHTML: _ctx.parseStatusTitle(item.status)
              }, null, 8, ["innerHTML"]),
              (_ctx.userInfoData && _ctx.userInfoData.leaves_value_type === 'Hours')
                ? (_openBlock(), _createBlock("p", _hoisted_8, " Leave Duration: " + _toDisplayString(_ctx.parseDurationType(item.duration_type, item.duration_hours)), 1))
                : _createCommentVNode("", true),
              _createVNode("p", null, "Leave Type: " + _toDisplayString(item.type_display_title), 1),
              (_ctx.$route.name !== 'View/Edit User')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    to: `/manage-employees/${_ctx.$route.params.uin}/leave-item/${item.uuid}`,
                    text: "View Comment"
                  }, null, 8, ["to"]))
                : (_ctx.$route.name === 'View/Edit User')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      onClick: ($event: any) => (_ctx.hrViewLeave(item.uuid)),
                      text: "View Comment"
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ]),
      (_ctx.userLeaveList && _ctx.userLeaveList.length > 0)
        ? _withDirectives((_openBlock(), _createBlock("div", {
            key: 1,
            class: "calculate",
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createVNode("p", null, "Total " + _toDisplayString(_ctx.leavesArray.length) + " selected.", 1),
            _hoisted_9,
            _withDirectives(_createVNode("textarea", {
              class: "comment",
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.reviewerComment = $event)),
              "aria-label": "supervisor comment",
              maxlength: "512"
            }, null, 512), [
              [_vModelText, _ctx.reviewerComment]
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_Button, {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.approveRequest(_ctx.leavesArray, $event, _ctx.reviewerComment))),
                async: true,
                text: "Approve",
                disabled: (_ctx.isHRAdminReadOnly && _ctx.$route.name === 'View/Edit User')
              }, null, 8, ["disabled"]),
              _createVNode(_component_Button, {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.declineRequest(_ctx.leavesArray, $event, _ctx.reviewerComment))),
                async: true,
                text: "Decline",
                disabled: (_ctx.isHRAdminReadOnly && _ctx.$route.name === 'View/Edit User')
              }, null, 8, ["disabled"])
            ])
          ], 544)), [
            [_vShow, _ctx.listToggle]
          ])
        : _createCommentVNode("", true)
    ], 544), [
      [_vShow, _ctx.listToggle]
    ])
  ], 64))
})